import { ViewConfig } from '../types';
import { VIEW_CONFIGS } from '../constants';

export const getViewConfig = (
  isTerritorialManager: boolean,
  isPilotUser: boolean,
): ViewConfig => {
  if (isTerritorialManager && isPilotUser) return VIEW_CONFIGS.territorialPilot;
  if (isTerritorialManager) return VIEW_CONFIGS.territorial;
  return VIEW_CONFIGS.nonTerritorialNonPilot;
};
